import { Upload, X } from "lucide-react";

export function ImageUpload({ imagePreview, onImageUpload, onImageRemove }) {
  return (
    <div>
      <label className="block text-sm font-medium text-[#111111] dark:text-white font-inter mb-2">
        Category Image
      </label>
      {imagePreview ? (
        <div className="relative">
          <img
            src={imagePreview}
            alt="Preview"
            className="w-full h-40 object-cover rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A]"
          />
          <button
            onClick={onImageRemove}
            className="absolute top-2 right-2 p-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-200 hover:scale-110 active:scale-95 shadow-lg"
            title="Delete image"
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-[#E5E7EB] dark:border-[#2A2A2A] rounded-lg cursor-pointer hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors">
          <Upload
            size={24}
            className="text-[#666666] dark:text-[#A0A0A0] mb-2"
          />
          <span className="text-sm text-[#666666] dark:text-[#A0A0A0] font-inter mb-1">
            Click to upload image
          </span>
          <span className="text-xs text-[#999999] dark:text-[#808080] font-inter">
            PNG, JPG, JPEG, GIF, WEBP (Max 5MB)
          </span>
          <input
            type="file"
            accept="image/png,image/jpg,image/jpeg,image/gif,image/webp"
            onChange={(e) => onImageUpload(e.target.files[0])}
            className="hidden"
          />
        </label>
      )}
    </div>
  );
}
